import {
  forwardRef,
  Ref,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';

import { BoneCaptcha, CaptchaCallbackResult, CaptchaType } from '@/sfe';

import { registerGeetest } from '../../api';
import { QQ_SITE_KEY, RECAPTCHA_SITE_KEY } from '../../config';

interface ICaptcha {
  id: string;
  invisibleMode: boolean;
  lang: string;
  plugins: CaptchaType[];
  onSuccess?: (res: CaptchaCallbackResult, val?: any) => void;
  onFail?: (res: string) => void;
  onDisplay?: (res: CaptchaCallbackResult) => void;
}

const Captcha = (
  { invisibleMode, lang, plugins, onSuccess, onFail, onDisplay }: ICaptcha,
  ref: Ref<unknown> | undefined,
) => {
  const [id, setId] = useState(
    'captcha_' + parseInt(Math.random() * 100000 + ''),
  );
  const [captcha, setCaptcha] = useState<any>();
  const captchaObj = useRef<any>();

  const callback = (
    res: CaptchaCallbackResult,
    cb?: (res: CaptchaCallbackResult) => void,
  ) => {
    if (res.fallback) {
      captcha.displayNext({
        id,
        callback,
      });
      return;
    }
    if (res.error) {
      // reset();
      onDisplay?.(res);
    } else {
      onSuccess?.(res);
      cb?.(res);
    }
  };

  useEffect(() => {
    const item = new BoneCaptcha({
      lang,
      geetStep1Request: registerGeetest,
      plugins,
      invisibleMode,
      recaptchaSiteKey: RECAPTCHA_SITE_KEY,
      qqSiteKey: QQ_SITE_KEY,
    });

    //setCaptcha(item);
    let haveGeet = false;

    item.pluginLoader.plugins.forEach((child: any) => {
      if (child.key == 'geecaptcha') {
        haveGeet = true;
        child?.preLoadGeet(id).then((res: any) => {
          if (!res) {
            item.pluginLoader.plugins = item.pluginLoader.plugins.filter(
              (v: any) => {
                if (v.key === 'geecaptcha') {
                  return false;
                }
                return v;
              },
            );
            item.captchas = item.captchas.filter((v: any) => {
              return v.key !== 'geecaptcha';
            });
          }
          setCaptcha(item);
          captchaObj.current = item;
          item.onMounted({
            id,
            callback,
          });
        });
      }
    });

    if (!haveGeet) {
      setCaptcha(item);
      captchaObj.current = item;
      item.onMounted({
        id,
        callback,
      });
    }
  }, []);

  const reset = () => {
    captcha.reset();
    onFail?.('reset');
  };

  const getCaptchaObj = async () => {
    const fn = (resolve: (value: unknown) => void) => {
      if (!captchaObj.current) {
        setTimeout(() => {
          fn(resolve);
        }, 100);
      } else {
        return resolve(captchaObj.current);
      }
    };

    return new Promise(fn);
  };

  const show = async (cb: (res: CaptchaCallbackResult) => void) => {
    const captchaObj: any = await getCaptchaObj();

    await captchaObj.show({
      id,
      callback: (res: any) => {
        callback(res, cb);
      },
    });
  };

  useEffect(() => {
    if (!captcha) return;
    captcha.setLang(lang);
  }, [captcha, lang]);

  useImperativeHandle(ref, () => ({
    show,
    reset,
  }));
  return (
    <div id={id} style={{ display: invisibleMode ? 'none' : 'block' }}></div>
  );
};

export default forwardRef(Captcha) as any;
